import { render, staticRenderFns } from "./MarkdownDialog.vue?vue&type=template&id=da84094e&"
import script from "./MarkdownDialog.vue?vue&type=script&lang=js&"
export * from "./MarkdownDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports